<div *ngIf="PartialViewReady" fxLayout="column" fxLayoutAlign="start stretch">
    <!-- Info Block for Unselected Student -->
    <div *ngIf="!SelectedStudent">
        <em>No student has been selected. Please use the "Student Search" button to the left to search for a student to view.</em>
    </div>

    <div *ngIf="!!SelectedStudent">
        <!-- Student Information Block -->
        <app-student-info
            *ngIf="User && !User.IsParent && !User.IsStudent"
            [SelectedCollege]="SelectedCollege"
            [SelectedStudent]="SelectedStudent"
            [User]="User"
            (update)="UpdateCollegeStudentID()"
        ></app-student-info>

        <!-- College ID (for Students Only) -->
        <div
            *ngIf="
                User &&
                User.IsStudent &&
                !!SelectedCollege &&
                !!SelectedCollege.CollegeID &&
                User.StudentID === SelectedCollege.StudentID
            "
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <div>
                {{ SelectedCollege.CollegeName }} ID#:
                {{ !!SelectedCollege.StudentCollegeID ? SelectedCollege.StudentCollegeID : 'Not yet provided.' }}
            </div>
            <button
                class="margin-left"
                mat-raised-button
                [color]="!!SelectedCollege.StudentCollegeID ? 'primary' : 'accent'"
                (click)="UpdateCollegeStudentID()"
            >
                Update
            </button>
        </div>

        <!-- Test History Block -->
        <div class="testhistorydiv" *ngIf="SelectedStudent.TestHistory && SelectedStudent.TestHistory.length">
            <button mat-raised-button color="primary" (click)="ToggleTestHistory()">
                {{ ShowTestHistory ? 'Hide' : 'Show' }} Tests History
            </button>
        </div>
        <div class="testhistorydiv" *ngIf="SelectedStudent && (!SelectedStudent.TestHistory || !SelectedStudent.TestHistory.length)">
            <em>This student currently has no available college related test score/history information available to display.</em>
        </div>
        <test-history class="testhistory" *ngIf="ShowTestHistory" [History]="SelectedStudent.TestHistory"></test-history>

        <!-- Missing College Block -->
        <div *ngIf="User && User.IsStudent && (!FilteredStudentCollegeInfo || !FilteredStudentCollegeInfo.length)">
            <p>
                No college has been selected yet for the selected school year.<span
                    *ngIf="SelectedCollege && SelectedCollege.HistoricalRecord !== true"
                >
                    Please use the button below to add a college choice for the selected school year.</span
                >
            </p>
        </div>

        <!-- Addition Buttons Block -->
        <div *ngIf="User && User.Roles.IsStudent && CanAddTerms" fxLayout="row" fxLayoutAlign="start start">
            <button
                mat-raised-button
                color="primary"
                (click)="AddCollegeChoice()"
                [disabled]="
                    FilteredStudentCollegeInfo &&
                    !!FilteredStudentCollegeInfo.length &&
                    FilteredStudentCollegeInfo[FilteredStudentCollegeInfo.length - 1].DualEnrollStudentID == null
                "
            >
                Add New College
            </button>
            <button
                mat-raised-button
                color="primary"
                (click)="AddCollegeTerm()"
                [disabled]="!SelectedCollege || SelectedCollege.DualEnrollStudentID == null"
            >
                Add New Term
            </button>
        </div>

        <!-- Student College Records Block -->
        <app-student-college-records
            [AcceleratedDegreePrograms]="AcceleratedDegreePrograms"
            [AvailableColleges]="AvailableColleges"
            [DualEnrollmentPrograms]="DualEnrollmentPrograms"
            [StudentCollegeRecords]="FilteredStudentCollegeInfo"
            [SelectedCollege]="SelectedCollege"
            [SelectedSchoolYear]="SelectedSchoolYear"
            [Counselors]="Counselors"
            [ShowAgreements]="ShowAgreements"
            [SmallDisplay]="SmallDisplay"
            [User]="User"
            (add)="AddStudentCollegeRecord($event)"
            (cancel)="CancelCollegeChoice($event)"
            (change)="CollegeChange($event)"
            (remove)="RemoveCollegeChoice($event)"
            (programChange)="ProgramOptionChange($event)"
            (select)="SelectCollegeRecord($event)"
            (toggleAgreements)="ToggleAgreements($event)"
            (update)="UpdateStudentCollegeRecord($event)"
            (updateprogram)="UpdateStudentCollegeProgram($event)"
        ></app-student-college-records>

        <!-- Dual Enrollment Program Selection Block -->
        <div
            *ngIf="
                User &&
                (User.IsCounselor || User.IsSchoolAdmin || User.IsDistrictAdmin || User.IsDeveloper) &&
                SelectedCollege &&
                SelectedCollege.DualEnrollmentProgramID == null &&
                SelectedCollege.HistoricalRecord !== true
            "
        >
            <strong
                >This student has not yet had a Dual Enrollment Program choice made for the
                {{ SelectedCollege.SchoolYear | schoolYear }} {{ SelectedCollege.Term.TermCode | collegeTerm }} Term for
                {{ SelectedCollege.CollegeName }}{{HasCompletedOrientation !== true && RequiresOrientation === true ? ' and has not completed their orientation' : ''}}. 
                Please use the selection box below to make a program selection for this
                student {{HasCompletedOrientation !== true && RequiresOrientation === true ? ' and please update their orientation status using the red button below' : ''}}.</strong
            >
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field floatPlaceholder="never">
                    <mat-select
                        [(ngModel)]="DualEnrollmentProgramChoice"
                        placeholder="Select Program"
                        (selectionChange)="ProgramOptionChange($event)"
                    >
                        <mat-option *ngFor="let pgm of DualEnrollmentPrograms" [value]="pgm.ProgramID">{{ pgm.Name }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field floatPlaceholder="never" *ngIf="DualEnrollmentProgramChoice == 3">
                    <mat-select [(ngModel)]="AcceleratedDegreeProgramChoice" placeholder="Select Degree Program">
                        <mat-option *ngFor="let dpgm of AcceleratedDegreePrograms" [value]="dpgm.AcceleratedDegreeProgramID">{{
                            dpgm.Name
                        }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="DualEnrollmentProgramChoice != null" fxLayout="row" fxLayoutAlign="start start">
                <em>This program requires {{ DualEnrollmentProgramChoice | DualEnrollmentCredits }}</em>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <button
                    mat-raised-button
                    color="primary"
                    [disabled]="
                        DualEnrollmentProgramChoice == null ||
                        (HasCompletedOrientation !== true && RequiresOrientation === true) ||
                        (DualEnrollmentProgramChoice == 3 && AcceleratedDegreeProgramChoice == null)
                    "
                    (click)="SetDualEnrollmentProgram()"
                >
                    Save Program Choice
                </button>
            </div>
            <div *ngIf="DualEnrollmentProgramChoice != null && HasCompletedOrientation !== true && RequiresOrientation === true" fxLayout="row" fxLayoutAlign="start start">
                <em class="mat-error">Please update orientation status using the red button below before saving program choice.</em>
            </div>
        </div>

        <!-- College Advisor, Admin, and Support Staff Warning Block -->
        <div
            *ngIf="
                User &&
                (User.IsAdvisor || User.IsCollegeAdmin || User.IsCollegeSupport) &&
                SelectedCollege &&
                SelectedCollege.FormStatus < 5 &&
                SelectedCollege.HistoricalRecord !== true
            "
        >
            <!-- Text panel for when they can't see details yet -->
            <div>
                This student's selected Dual Enrollment form has not yet been approved by all parties. Please monitor the notification
                panel on your home page for an alert when this student's form has received all approvals and is available for approving
                or revising.
            </div>
        </div>

        <!-- Timeline Block -->
        <div
            class="mat-whiteframe-14dp timelineblock"
            *ngIf="
                SelectedCollege &&
                SelectedCollege.DualEnrollStudentID != null &&
                SelectedCollege.HistoricalRecord !== true &&
                User &&
                !User.IsParent
            "
        >
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
                <h2 class="mat-title">
                    My {{ SelectedCollege.CollegeName }} - {{ SelectedCollege.Term.TermCode | collegeTerm }}
                    {{ SelectedCollege.Term.CollegeSchoolYear | collegeSchoolYear: SelectedCollege.CollegeID }} Term Progress
                </h2>
                <div *ngIf="StudentSchedule && StudentSchedule.length">
                    <button mat-raised-button color="primary" (click)="DownloadPDF()">Download Courses PDF</button>
                </div>
            </div>
            <div style="width: 90%; margin: 15px auto">
                <app-timeline
                    [steps]="Steps"
                    [currentStep]="TimelineStep"
                    back-color="primary-50"
                    color="primary-500"
                    style="width: 100%"
                ></app-timeline>
            </div>
            <div
                style="color: red; margin-top: 20px"
                *ngIf="SelectedCollege.ParentHasApproved !== true && SelectedCollege.HistoricalRecord !== true"
            >
                The selected college term has not yet been approved for Dual Enrollment participation by your parent or guardian. This
                term cannot be approved by your school counselor until parent or guardian approval for DE participation has been
                granted.
            </div>
        </div>

        <!-- Parent FERPA Warning Block -->
        <div *ngIf="SelectedCollege && User && User.IsParent && SelectedCollege.ParentHasApproved === true" style="margin: 10px 0">
            The <a href="https://studentprivacy.ed.gov/faq/if-student-under-18-enrolled-both-high-school-and-local-college-do-parents-have-right-inspect" 
                target="_blank">FERPA</a> (Family Educational
            Rights and Privacy Act) regulations for <i>postsecondary</i> institutions regulates the information which can be shared
            with parents. Parents should obtain information from their child's school/school counselor(s).
        </div>

        <!-- Agreements Block (Student) -->
        <agreements-panel
            *ngIf="
                User &&
                User.IsStudent &&
                SelectedCollege &&
                SelectedCollege.HistoricalRecord !== true &&
                (SelectedCollege.StudentCollegeAgreementApproved !== true ||
                    SelectedCollege.StudentPolkAgreementApproved !== true ||
                    ShowAgreements)
            "
            [AgreementChecks]="AgreementChecks"
            [AsParent]="false"
            [PCSBAgreementDate]="PCSBAgreementDate"
            [PCSBAgreementText]="PCSBAgreementText"
            [PCSBAgreementConsentText]="PCSBAgreementConsentText"
            [SelectedCollege]="SelectedCollege"
            [SelectedSchoolYear]="SelectedSchoolYear"
            [StudentPolkAgreementApproved]="SelectedCollege.StudentPolkAgreementApproved"
            [User]="User"
            (submit)="StudentSubmitApproval($event)"
        ></agreements-panel>

        <!-- Agreements Block (Parent) -->
        <agreements-panel
            *ngIf="
                User &&
                User.IsParent &&
                SelectedCollege &&
                SelectedCollege.HistoricalRecord !== true &&
                (SelectedCollege.ParentHasApproved !== true || ShowAgreements)
            "
            [AgreementChecks]="AgreementChecks"
            [AsParent]="true"
            [PCSBAgreementDate]="PCSBAgreementDate"
            [PCSBAgreementText]="PCSBAgreementText"
            [PCSBAgreementConsentText]="PCSBAgreementConsentText"
            [SelectedCollege]="SelectedCollege"
            [SelectedSchoolYear]="SelectedSchoolYear"
            [StudentPolkAgreementApproved]="SelectedCollege.ParentHasApproved"
            [User]="User"
            (submit)="ParentSubmitApproval($event)"
        ></agreements-panel>

        <!-- Alerts Block -->
        <div
            *ngIf="
                User &&
                !User.IsParent &&
                !User.IsAdvisor &&
                !User.IsCollegeAdmin &&
                !User.IsCollegeSupport &&
                SelectedCollege &&
                SelectedCollege.FormStatus == 2 &&
                SelectedCollege.HistoricalRecord !== true
            "
            style="margin-top: 10px"
        >
            <em
                >The selected Dual Enrollment form above is currently awaiting certification of your Dual Enrollment Program
                Eligibility by your school's school counselor. Please contact your school counselor for more information on
                available Dual Enrollment Programs and an update on your certification status.</em
            >
        </div>

        <!-- Alerts Block (Completed Orientation Status) -->
        <div
            *ngIf="
                User &&
                !User.IsParent &&
                !User.IsAdvisor &&
                !User.IsCollegeAdmin &&
                !User.IsCollegeSupport &&
                SelectedCollege &&
                SelectedCollege.HistoricalRecord !== true &&
                HasCompletedOrientation !== true &&
                RequiresOrientation === true
            "
            style="margin-top: 10px"
        >
            <em
                >The selected Dual Enrollment form above is currently awaiting confirmation of completion of your college orientation 
                by your school's school counselor. Please contact your school counselor for more information on college orientation 
                and an update on your orientation completion status</em
            >
        </div>

        <!-- Course Selection Panel Block -->
        <app-course-selection-panel
            class="courseselectionblock"
            *ngIf="
                User &&
                !User.IsParent &&
                SelectedCollege &&
                (((User.IsAdvisor || User.IsCollegeAdmin || User.IsCollegeSupport) && SelectedCollege.FormStatus >= 5) ||
                    (!User.IsAdvisor && !User.IsCollegeAdmin && !User.IsCollegeSupport && SelectedCollege.FormStatus >= 3) ||
                    SelectedCollege.HistoricalRecord === true)
            "
            [CanBypassAdmin]="CanBypassAdmin"
            [Courses]="StudentSchedule"
            [SelectedCollege]="SelectedCollege"
            [SelectedCollegeCourses]="SelectedCollegeCourses"
            [SelectedCollegeDepartments]="SelectedCollegeDepartments"
            [SmallDisplay]="SmallDisplay"
            [User]="User"
            (approveallcourses)="ApproveAllCourses($event)"
            (approvecourse)="ApproveCourseChoice($event)"
            (eligilibity)="EligibilityHandler($event)"
            (fasttrack)="FastTrackHandler($event)"
            (refpdf)="DownloadRefPDF()"
            (removecourse)="RemoveCourseChoice($event)"
            (returnform)="ReturnForm($event)"
            (selectcourse)="SelectCourse($event)"
            (setcourseref)="SetCourseReferenceNumber($event)"
            (setcoursealtref)="SetCourseAltReferenceNumber($event)"
            (undoremovecourse)="UndoRemoveCourse($event)"
        ></app-course-selection-panel>

        <!-- Completed Orientation Status Block -->
        <div
            class="orientationblock"
            *ngIf="
                SelectedCollege &&
                HasCompletedOrientation !== true &&
                RequiresOrientation === true &&
                SelectedCollege.HistoricalRecord !== true &&
                User &&
                (User.IsCounselor || User.IsSchoolAdmin || User.IsDistrictAdmin || User.IsDeveloper)
            "
        >
            <div>
                The selected Dual Enrollment form above is currently awaiting confirmation of completion of the selected  
                college's orientation. This term cannot be approved until the student has provided proof of completion of
                the college orientation to their school counselor.
            </div>
            <button mat-raised-button color="warn" (click)="UpdateOrientationStatus(!HasCompletedOrientation)">Update Orientation Status</button>
        </div>

        <!-- Proxy Parental Approval Block -->
        <div
            class="proxyblock"
            *ngIf="
                SelectedCollege &&
                SelectedCollege.ParentHasApproved !== true &&
                SelectedCollege.HistoricalRecord !== true &&
                User &&
                (User.IsCounselor || User.IsSchoolAdmin || User.IsDistrictAdmin || User.IsDeveloper)
            "
        >
            <div>
                The selected college term has not yet been approved for Dual Enrollment participation by the parent of the student.
                This term cannot be approved by school counselors for school administrator or college advisor access until parent
                approval for DE participation has been granted.
            </div>
            <button mat-raised-button color="warn" [disabled]="HasCompletedOrientation !== true && RequiresOrientation === true" (click)="ProxyApprove()">Approve on behalf of parent</button>
            <span *ngIf="HasCompletedOrientation !== true && RequiresOrientation === true" class="mat-error">Please update orientation status using the red button above before approving.</span>
        </div>

        <!-- Optional Notes Block -->
        <div class="notesblock" *ngIf="SelectedCollege && SelectedCollege.Term && User && !User.IsParent">
            <app-request-notes
                [SelectedCollege]="SelectedCollege"
                [SmallDisplay]="SmallDisplay"
                [StudentScheduleNotes]="StudentScheduleNotes"
                [User]="User"
                (addnote)="AddNote($event)"
                (removenote)="RemoveNote($event)"
            ></app-request-notes>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/requests/requests.component.html